import React from "react";
import { render } from "react-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import TagManager from "react-gtm-module";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Routes from "./routes";
import reportWebVitals from "./reportWebVitals";
import "./styles/reset.scss";
import "./styles/global.scss";
import "./styles/mixins.scss";
import "./styles/icons.scss";
import "./styles/variables.scss";

const providerConfig = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  ...(process.env.REACT_APP_AUTH0_AUDIENCE
    ? { audience: process.env.REACT_APP_AUTH0_AUDIENCE }
    : null),
  redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
  cacheLocation: "localstorage",
  useRefreshTokens: true,
};

Sentry.init({
  dsn: "https://a5106761309d4539858526c44163aaae@o1137260.ingest.sentry.io/6303025",
  integrations: [new BrowserTracing()],
  tracesSampleRate: process.env.NODE_ENV === "development" ? 0 : 1.0,
  environment: process.env.NODE_ENV,
});

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CODE,
};

TagManager.initialize(tagManagerArgs);

const queryClient = new QueryClient();
render(
  <React.StrictMode>
    <Auth0Provider {...providerConfig}>
      <QueryClientProvider client={queryClient}>
        <Routes />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
